import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { getAuth } from 'firebase/auth';
import { loadStripe } from '@stripe/stripe-js';
import './TrialExpiredModal.css';

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY);

const TrialExpiredModal = ({ isOpen, onContinue }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubscribe = async () => {
    try {
      setLoading(true);
      setError('');

      const auth = getAuth();
      const idToken = await auth.currentUser.getIdToken();

      const response = await fetch('https://us-central1-thebasics-be824.cloudfunctions.net/createCheckoutSession', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${idToken}`
        },
        body: JSON.stringify({
          priceId: process.env.REACT_APP_STRIPE_PRICE_ID,
        })
      });

      if (!response.ok) {
        throw new Error('Failed to create checkout session');
      }

      const { sessionId } = await response.json();
      const stripe = await stripePromise;
      const { error: stripeError } = await stripe.redirectToCheckout({ sessionId });

      if (stripeError) {
        throw stripeError;
      }
    } catch (err) {
      console.error('Error starting checkout:', err);
      setError('Failed to start checkout. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <AnimatePresence>
      <motion.div
        className="trial-expired-modal-overlay"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
      >
        <motion.div
          className="trial-expired-modal-content"
          initial={{ scale: 0.95, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          exit={{ scale: 0.95, opacity: 0 }}
        >
          <div className="trial-expired-header">
            <div className="expired-icon">🎯</div>
            <h2>Trial Period Ended</h2>
          </div>
          
          <div className="trial-expired-body">
            <p>Your 14-day trial has come to an end.</p>
            <p>Continue your journey of personal growth and development!</p>
            {error && <p className="error-message">{error}</p>}
          </div>

          <div className="trial-expired-actions">
            <motion.button
              className="subscribe-button"
              onClick={handleSubscribe}
              whileHover={{ scale: 1.02 }}
              whileTap={{ scale: 0.98 }}
              disabled={loading}
            >
              {loading ? 'Processing...' : 'Subscribe Now'}
            </motion.button>

            <motion.button
              className="continue-button"
              onClick={onContinue}
              whileHover={{ scale: 1.02 }}
              whileTap={{ scale: 0.98 }}
              disabled={loading}
            >
              Continue with Limited Access
            </motion.button>
          </div>
        </motion.div>
      </motion.div>
    </AnimatePresence>
  );
};

export default TrialExpiredModal; 